import styled, { css } from 'styled-components';
import { getColorByName } from '~/helpers/getColors';
import getFontFamily from '~/helpers/getFontFamily';
import {
  CTABasics,
  CTACommonBeforeStyles,
  CTAAnimationBasics,
} from './CTA.basic';
import { getPaddingX, getPaddingY, getFontSize } from '../CTA.helpers';

export const CTAprimarySkin = css`
  ${CTABasics};
  padding: ${(props) => getPaddingY(props.size) - 2}px
    ${(props) => getPaddingX(props.size)}px;
  font-family: ${(props) => getFontFamily(props.theme.cta.primaryFontFamily)};
  font-size: ${(props) => getFontSize(props.size)};
  color: ${(props) =>
    getColorByName(props.theme, props.theme.cta.primaryFontColor)};
  background: ${(props) =>
    getColorByName(props.theme, props.theme.cta.primaryBgColor)};
  line-height: ${(props) => props.theme.cta.primaryLineHeight};

  .iconBefore,
  .iconAfter {
    svg {
      max-height: ${(props) => getFontSize(props.size)};
      width: auto;
    }
  }

  &:before {
    content: '';
    background: ${(props) =>
      getColorByName(props.theme, props.theme.cta.primaryBgHoverColor)};
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
    height: 100%;
    transform: scaleX(0);
    transform-origin: right center;
    transition: transform 0.15s cubic-bezier(0.45, 0.05, 0.3, 0.95) 0.15s;
    z-index: 1;
  }

  &:hover {
    color: ${(props) =>
      getColorByName(props.theme, props.theme.cta.primaryHoverFontColor)};
  }

  &:hover:before {
    transition: transform 0.15s cubic-bezier(0.45, 0.05, 0.3, 0.95) 0s;
    transform-origin: left center;
    transform: scaleX(1);
  }

  ${({ theme, isBrand }) =>
    isBrand &&
    css`
      color: ${getColorByName(theme, theme.cta.brand.primaryFontColor)};
      background: ${getColorByName(theme, theme.cta.brand.primaryBgColor)};
      border: ${theme.cta.brand.primaryBorder};

      &:before {
        ${CTACommonBeforeStyles};
        background: ${getColorByName(
          theme,
          theme.cta.brand.primaryBgHoverColor,
        )};
      }
    `};
`;

const CTAprimaryWithAniIconSkin = css`
  ${CTAprimarySkin};
  ${CTAAnimationBasics};
`;

export const CTAprimary = styled.div`
  ${CTAprimarySkin}
`;

export const CTAprimaryWithAniIcon = styled.div`
  ${CTAprimaryWithAniIconSkin}
`;

export const CTAiconOnly = styled.div`
  &:hover rect {
    fill: ${(props) => getColorByName(props.theme, 'deepHumanBlue100')};
  }

  &:hover path {
    fill: ${(props) => getColorByName(props.theme, 'white500')};
    stroke: ${(props) => getColorByName(props.theme, 'white500')};
  }
`;
